import React from 'react';
import {View} from 'react-native';
import {GetHolderProfileCabinetResponsePayload, GetProfileSettingsResponsePayload} from '../../../shared/models/api';
import Screen from '../../../shared/components/screen';
import {useStyles} from '../../../shared/hooks/styles';
import {ProfileInfo} from './components/profileInfo';
import {ContentWithRightImage} from '../../../shared/components/contentWithRightImage';
import {CardInfo} from '../../../shared/components/cardInfo';

interface IProps {
  holderProfile: GetHolderProfileCabinetResponsePayload | null;
  profileSettings: GetProfileSettingsResponsePayload | null;
}

export default ({holderProfile}: IProps) => {
  const styles = useStyles(({theme}) => {
    return {
      container: {
        marginHorizontal: 60,
        marginTop: 31,
        marginBottom: theme.screen.bottomOffset,
      },
      h2: {
        ...theme.fonts.h2,
      },
    };
  });
  return (
    <Screen>
      <View testID='profile-desktop-container-id' style={styles.container}>
        <ContentWithRightImage icon={<CardInfo />} hideImage={true}>
          <ProfileInfo profile={holderProfile} />
        </ContentWithRightImage>
      </View>
    </Screen>
  );
};
